import backofficeService from '../../api/backoffice'

export default {
  getMerchantPaymentMethods(mappingId, donationCategoryId) {
    return backofficeService.Api()
      .get(`stripe/merchant-customer/${mappingId}/payment-methods`, { params: { donationCategoryId } })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  deleteMerchantPaymentMethod(mappingId, paymentMethodId, donationCategoryId) {
    return backofficeService.Api()
      .delete(`stripe/merchant-customer/${mappingId}/payment-methods/${paymentMethodId}`, { params: { donationCategoryId } })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getCustomerById(data) {
    return backofficeService.Api().post('stripe/customer/get', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  createCustomer(data) {
    return backofficeService.Api().post('stripe/customer/create', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  changeDefaultCard(data) {
    return backofficeService.Api().post('stripe/customer/changeDefaultCard', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  chargeCustomer(data) {
    return backofficeService.Api().post('stripe/customer/charge', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  SubListByCustomer(data) {
    return backofficeService.Api().post('stripe/subscription/list', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getAllCard(data) {
    return backofficeService.Api().post('stripe/card/getAll', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  deleteCard(data) {
    return backofficeService.Api().post('stripe/card/delete', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  addCard(data) {
    return backofficeService.Api().post('stripe/card/add', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

}
